<template>
  <div>
    <v-container style="max-width: 1000px;">
      <h1>{{ $route.query.customerFirstName ? `${$route.query.customerFirstName},` : null }} Welcome to havebike Support</h1>

      <v-alert type="info" outlined text dense class="mt-4">
        <strong>Service Update:</strong> We are currently seeing a very high call volume - our team therefore may not be able to answer the phone. If you are unable to get through, please use the webchat or email options below.
      </v-alert>

      <v-alert v-if="this.$route.query.panel == 1" type="success" outlined text dense class="mt-2">
        Please use the form below to approve or ask any questions about the additional costs on your service.
      </v-alert>

      <v-row class="mt-8">
        <v-col :cols="12" :md="6">
          <p>Our customer service team are all keen cyclists and are here to help you with any query you may have. We are a small, 2 person team, working 5 days a week out of our central London workshop. Please use the sections below to help find the best (and quickest) method of getting help!</p>
          <p>Our working hours are 9am - 6pm, Monday - Friday.</p>
          <p>There are a couple of different options available, depending on the type of support you are looking for:</p>
          <ul>
            <!-- <li><strong>Support Docs</strong></li> -->
            <li><strong>Web Chat</strong></li>
            <li><strong>Email</strong></li>
            <li><strong>Phone</strong></li>
          </ul>
        </v-col>
        <v-col :cols="12" :md="6">
          <img src="https://www.havebike.co.uk/wp-content/uploads/2020/02/havebike_tribe_cropped_WEB.jpg" alt="havebike Team" class="us_img">
        </v-col>
      </v-row>

      <v-divider class="mt-8 mb-8" />

      <h2 class="primary--text">What best describes the reason you are looking for support?</h2>

      <v-expansion-panels class="mt-8" focusable accordion v-model="panel">
        <v-expansion-panel>
          <v-expansion-panel-header><strong>I would like to book my bike in for a service / repair</strong></v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-divider class="mb-4" />

            <v-alert type="info" text outlined dense border="top">
              We are currently experiencing longer than usual lead times on certain parts. If your bike requires parts, you may experience a delay in receiving your bicycle back from us. We will endevour to keep you updated with estimated delivery dates from our suppliers.
            </v-alert>

            <p>Please choose one of the options below in order to get in touch</p>

            <p class="green--text"><strong>Fastest - <i>Web Chat</i></strong></p>
            <v-btn
              color="primary"
              depressed
              @click="openBeacon('ff19383e-c424-4eb4-a7fa-87564a74e071')"
            >
              Launch Web Chat
            </v-btn>

            <p class="orange--text mt-4"><strong>Longer Wait Times - <i>Email</i></strong></p>
            <a href="mailto:info@havebike.co.uk">
              <v-btn
                color="primary"
                depressed
              >
                Email us - info@havebike.co.uk
              </v-btn>
            </a>

            <p class="orange--text mt-4"><strong>Longer Wait Times - <i>Request Call Back</i></strong></p>
            <v-btn
              color="primary"
              depressed
              @click="showBeaconMessage('d09c616c-8444-428c-a4cd-eecf2e807041', '4b3448e2-9c06-41b8-b4e9-6fa5fe324208')"
            >
              Request Call Back
            </v-btn>

          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header><strong>My bike is in the workshop</strong></v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-divider class="mb-4" />

            <v-alert type="info" text outlined dense border="top">
              We are currently experiencing longer than usual lead times on certain parts. If your bike is currently awaiting parts, we will endevour to update you as soon as we have an expected delivery date.
            </v-alert>

            <p>Please choose one of the options below in order to get in touch</p>

            <p class="green--text"><strong>Fastest - <i>Web Chat</i></strong></p>
            <v-btn
              color="primary"
              depressed
              @click="openBeacon('f359d789-bb17-4040-bb97-10eedaa368f8')"
            >
              Launch Web Chat
            </v-btn>

            <p class="orange--text mt-4"><strong>Longer Wait Times - <i>Email</i></strong></p>
            <a href="mailto:bookings@havebike.co.uk">
              <v-btn
                color="primary"
                depressed
              >
                Email us - bookings@havebike.co.uk
              </v-btn>
            </a>

            <p class="orange--text mt-4"><strong>Longer Wait Times - <i>Phone</i></strong></p>
            <a href="tel:03330509287">
              <v-btn
                color="primary"
                depressed
              >
                Call us - 0333 050 9287
              </v-btn>
            </a>

          </v-expansion-panel-content>
        </v-expansion-panel>
       <v-expansion-panel>
          <v-expansion-panel-header><strong>My bike is due for collection today or the next couple of days</strong></v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-divider class="mb-4" />
            <v-alert type="info" text outlined dense border="top">
              Timeslots are sent out the evening before collection / return, unfortuantly we are unable to give timeslots earlier than this.
            </v-alert>
            <p class="green--text"><strong>Fastest - <i>Web Chat</i></strong></p>
            <v-btn
              color="primary"
              depressed
              @click="openBeacon('ad7e914c-56e2-40be-a298-34f6531e0135')"
            >
              Launch Web Chat
            </v-btn>

            <p class="orange--text mt-4"><strong>Longer Wait Times - <i>Phone</i></strong></p>
            <a href="tel:03330509287">
              <v-btn
                color="primary"
                depressed
              >
                Call us - 0333 050 9287
              </v-btn>
            </a>
          </v-expansion-panel-content>
        </v-expansion-panel>
       <v-expansion-panel>
          <v-expansion-panel-header><strong>I would like to give feedback or make a complaint</strong></v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-divider class="mb-4" />
            <p class="green--text"><strong>Fastest - <i>Web Chat</i></strong></p>
            <v-btn
              color="primary"
              depressed
              @click="openBeacon('d8f0c067-89b2-43c5-ac0b-43629a9ff1a0')"
            >
              Launch Web Chat
            </v-btn>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </div>
</template>

<script>
import HasBeacon from '@/mixins/HasBeacon'
export default {
  name: 'MainPage',

  mixins: [ HasBeacon ],

  data () {
    return {
      beacon: false,
      panel: null
    }
  },

  mounted () {
    window.Beacon('prefill', {
      name: this.$route.query.customerName,
      email: this.$route.query.customerEmail,
      subject: this.$route.query.beaconSubject,
      text: this.$route.query.beaconText
    })

    if (this.$route.query.panel) {
      this.panel = parseInt(this.$route.query.panel)
    }

    if (this.$route.query.beacon) {
      this.openBeacon(
        this.$route.query.beacon
      )
    }
  }
}
</script>

<style lang="css">
  .us_img {
    width: 100%;
    height: 260px;
    object-fit: cover;
  }
</style>